import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./styles.module.css";

type ModalPropsTypes = {
  show: boolean;
  closing: boolean;
  children: React.ReactNode;
  title: string;
  onClose: () => void;
};

function Modal({ show, closing, children, onClose, title }: ModalPropsTypes) {
  const [isBrowser, setIsBrowser] = useState(false);
  const previousOverflowRef = useRef<string | undefined>(undefined);
  const modalClassName = closing
    ? `${styles.modal} ${styles.closing}`
    : `${styles.modal} ${styles.opening}`;

  useEffect(() => {
    setIsBrowser(true);
    const bodyStyle = document.body.style;

    if (show) {
      if (previousOverflowRef.current === undefined) {
        previousOverflowRef.current = bodyStyle.overflow;
      }
      window.scrollTo({ top: 0 });
      bodyStyle.overflow = "hidden";

      return () => {
        bodyStyle.overflow = previousOverflowRef.current ?? "";
      };
    } else if (previousOverflowRef.current !== undefined) {
      bodyStyle.overflow = previousOverflowRef.current;
      previousOverflowRef.current = undefined;
    }

    return undefined;
  }, [show]);

  const modalContent = show ? (
    <div className={styles.modalOverlay}>
      <div className={modalClassName}>
        <div className={styles.modalHeader}></div>
        <div className={styles.modalTitleContainer}>
          <h2 className={styles.title}>{title}</h2>
          {/* <div className={styles.closeSymbol} onClick={onClose}>X</div> */}
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  ) : null;

  if (isBrowser) {
    return ReactDOM.createPortal(modalContent, document.getElementById("modal-root")!);
  } else {
    return null;
  }
}

export default Modal;
